import Clients from "pages/LandingPages/clients";

export default function ClientPage() {
  return <Clients />;
}
